var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",on:{"click":_vm.back}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/icon-backcenter.png"),"alt":""}}),_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.backStr.cn || '返回赛事中心'))]),_c('div',[_vm._v(" "+_vm._s(_vm.backStr.en || 'BACK TO COMPETITION CENTER')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }